import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	searchCurrentPage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchCurrentPage: {
		id: 'filter-refinement.search-field.keyboard-shortcuts.search-current-page',
		defaultMessage: 'Search on current page',
		description: 'Command in the command palette to trigger the page search',
	},
});
export default messages;
